import React from 'react';
import api from './api';
import './styles/index.css';

const TorneosMenu = ({ onBack, onVerTorneos, onCrearTorneo }) => {
  const user = api.getCurrentUser();
  const esBar = user?.tipoUsuario === 'bar';

  const handleLogout = () => {
    api.logout();
    window.location.reload();
  };

  return (
    <div className={`dart-league-dashboard torneos-menu ${esBar ? 'torneos-menu--admin' : ''}`}>
      {/* Header */}
      <div className="dashboard-header">
        <div className="user-info">
          <img src="/Logo26.png" alt="501 Dart League" className="dashboard-logo" />
          <div>
            <h1>🏆 Torneos</h1>
            <p>Hola, <strong>{user?.nombre || user?.username}</strong></p>
            {esBar && <span className="admin-badge">⚙️ Administrador</span>}
          </div>
        </div>
        <div className="header-buttons">
          <button onClick={onBack} className="back-button">
            ← Volver
          </button>
          <button onClick={handleLogout} className="logout-button">
            Cerrar sesión
          </button>
        </div>
      </div>

      {/* Opciones del menú */}
      <div className="torneos-menu-container">
        <div className="torneos-menu-options">
          {/* Ver Torneos */}
          <div className="torneos-menu-card" onClick={onVerTorneos}>
            <div className="menu-card-icon">👁️</div>
            <div className="menu-card-content">
              <h3>Ver Brackets</h3>
              <p>Consulta todos los torneos y sigue las partidas</p>
            </div>
            <div className="menu-card-arrow">→</div>
          </div>

          {/* Crear Torneo - Solo para bares */}
          {esBar && (
            <div className="torneos-menu-card" onClick={onCrearTorneo}>
              <div className="menu-card-icon">➕</div>
              <div className="menu-card-content">
                <h3>Crear Torneo</h3>
                <p>Crea un nuevo torneo y gestiona los participantes</p>
              </div>
              <div className="menu-card-arrow">→</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TorneosMenu;
